import { useCallback, useRef } from 'react';
import useThrottledWindowScrollPosition from 'hooks/useThrottledWindowScrollPosition';
const useProductListingTrackScrollPosition = ({
  hasScrollPositionBeenRestored,
  lastProductPath,
  loadMoreClickCount,
  previousScrollPosition,
  setScrollDataInSessionStorage,
  isScrollTrackingDisabled = false
}) => {
  // Use refs to access latest values without causing the callback identity to change.
  const lastProductPathRef = useRef(lastProductPath);
  lastProductPathRef.current = lastProductPath;
  const loadMoreClickCountRef = useRef(loadMoreClickCount);
  loadMoreClickCountRef.current = loadMoreClickCount;
  const hasScrollPositionBeenRestoredRef = useRef(hasScrollPositionBeenRestored);
  hasScrollPositionBeenRestoredRef.current = hasScrollPositionBeenRestored;
  const previousScrollPositionRef = useRef(previousScrollPosition);
  previousScrollPositionRef.current = previousScrollPosition;
  const onWindowScrollCallback = useCallback(updatedScrollPosition => {
    if (!isScrollTrackingDisabled && hasScrollPositionBeenRestoredRef.current && previousScrollPositionRef.current !== updatedScrollPosition) {
      setScrollDataInSessionStorage(prevData => ({
        ...prevData,
        lastProductPath: lastProductPathRef.current,
        loadMoreClickCount: loadMoreClickCountRef.current,
        scrollPosition: updatedScrollPosition
      }));
    }
  }, [isScrollTrackingDisabled, setScrollDataInSessionStorage]);
  useThrottledWindowScrollPosition({
    callback: onWindowScrollCallback,
    time: 1000,
    isScrollTrackingDisabled,
    previousScrollPosition
  });
};
export default useProductListingTrackScrollPosition;